import React from 'react';
import { TourQuestionnaire } from '../../../types';
import { cn } from '../../../lib/utils';

interface Step9_2Props {
  questionnaire: TourQuestionnaire;
  setQuestionnaire: React.Dispatch<React.SetStateAction<TourQuestionnaire>>;
  setStep: (step: number) => void;
  handleBack: () => void;
}

export const Step9_2: React.FC<Step9_2Props> = ({
  questionnaire,
  setQuestionnaire,
  setStep,
  handleBack,
}) => {
  // Selection is stored in questionnaire.accommodationType
  // Confirmation goes through setStep(9.3) so the tunnel can apply sanitizeQuestionnaire
  // via the wrapped setQuestionnaire passed from the tunnel

  const handleConfirm = () => {
    if (!questionnaire.accommodationType) return;
    setStep(9.3);
  };

  return (
    <div className="flex flex-col h-[100dvh] p-0 overflow-hidden bg-zinc-950">
      <div className="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar pb-32">
        <h2 className="text-2xl font-bold text-white">Hébergement</h2>
        <p className="text-zinc-400">
          Pour votre circuit de {questionnaire.logistics?.days} jours, comment souhaitez-vous organiser votre hébergement entre les étapes ?
        </p>

        <div className="space-y-3">
          <button
            onClick={() =>
              setQuestionnaire(prev => ({ ...prev, accommodationType: 'return' }))
            }
            className={cn(
              "w-full p-3.5 rounded-xl border text-left transition-all",
              questionnaire.accommodationType === 'return'
                ? "bg-emerald-500/20 border-emerald-500 text-white"
                : "bg-zinc-900 border-zinc-800 text-zinc-400 hover:border-zinc-700"
            )}
          >
            <div className="font-semibold text-sm">Retour au lieu de vacances</div>
            <div className="text-xs opacity-60">Je retourne à mon lieu de séjour initial chaque soir.</div>
          </button>

          <button
            onClick={() =>
              setQuestionnaire(prev => ({ ...prev, accommodationType: 'hotel' }))
            }
            className={cn(
              "w-full p-3.5 rounded-xl border text-left transition-all",
              questionnaire.accommodationType === 'hotel'
                ? "bg-emerald-500/20 border-emerald-500 text-white"
                : "bg-zinc-900 border-zinc-800 text-zinc-400 hover:border-zinc-700"
            )}
          >
            <div className="font-semibold text-sm">Hébergement à proximité</div>
            <div className="text-xs opacity-60">
              Je prévois un hébergement (gîte, auberge, logement insolite...) proche de la dernière activité de la journée.
            </div>
          </button>
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 z-30 bg-zinc-950/90 backdrop-blur-xl border-t border-white/10">
        <div className="max-w-7xl mx-auto p-4 md:p-6 flex gap-3">
          <button
            onClick={handleBack}
            className="flex-1 py-3 bg-zinc-800 text-white rounded-xl font-semibold text-sm hover:bg-zinc-700 transition-colors"
          >
            Retour
          </button>
          <button
            onClick={handleConfirm}
            disabled={!questionnaire.accommodationType}
            className="flex-[2] py-3 bg-emerald-500 text-white rounded-xl font-semibold text-sm hover:bg-emerald-600 transition-colors disabled:opacity-50 shadow-[0_0_15px_rgba(16,185,129,0.3)]"
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  );
};
